import React, {
    useCallback,
    useMemo,
    useState,
    useEffect,
} from 'react';
import './QueueScreen.css';
import { useCountdown } from '../hooks/useCountdown';
import openBg from '../assets/open_bg.jpg';
import openNightBg from '../assets/open_bg_night.jpg';
import housesBg from '../assets/houses.png';
import housesBackBg from '../assets/houses_back.png';
import housesNightBg from '../assets/houses_night.png';
import housesNightBackBg from '../assets/houses_night_back.png';
import logoImage from '../assets/logo.png';
import counterImage from '../assets/counter.png';
import timerImage from '../assets/timer.png';
import bannerImage from '../assets/banner.png';
import bannerPadImage from '../assets/pad_banner.png';
import bilboardImage from '../assets/bilboard.png';
import roadImage from '../assets/road.png';
import roadNightImage from '../assets/road_night.png';
import shopImage from '../assets/shop.png';
import people1 from '../assets/people1.png';
import people2 from '../assets/people2.png';
import people3 from '../assets/people3.png';
import people4 from '../assets/people4.png';
import people5 from '../assets/people5.png';
import people6 from '../assets/people6.png';
import people7 from '../assets/people7.png';
import people8 from '../assets/people8.png';
import people9 from '../assets/people9.png';
import people10 from '../assets/people10.png';
import pashalka1 from '../assets/pashalka1.png';
import pashalka2 from '../assets/pashalka2.png';
import pashalka3 from '../assets/pashalka3.png';
import pashalka4 from '../assets/pashalka4.png';
import blue_btn from '../assets/blue_btn.png';
import pink_btn from '../assets/pink_btn.png';
import stolb from '../assets/stolb.png';
import close from '../assets/close.png';
import ic_arrow from '../assets/ic_arrow.svg';
import winnersBtn from '../assets/winners.png';
import winnerTopImage from '../assets/winnerTop.png';
import ticketImage from '../assets/ticket.png';
import ticketTopImage from '../assets/ticket_top.png';
import deviceImage from '../assets/device.png';
import airImage from '../assets/air.png';
import stat_btn from '../assets/stat_btn.png';
import ic_back from '../assets/ic_back.png';
import mobileCounter from '../assets/mobileCounter.png';
import mobileTimer from '../assets/mobileTimer.png';
import mobileWinner from '../assets/mobileWinner.png';
import mobile_header_ticket from '../assets/mobile_header_ticket.png';
import { UserQueueData, WaittypeAggItem, WinnerItem } from '../types';

import b1Image from '../assets/b1.png';
import b2Image from '../assets/b2.png';
import b3Image from '../assets/b3.png';
import b4Image from '../assets/b4.png';
import b5Image from '../assets/b5.png';
import b6Image from '../assets/b6.png';
import b7Image from '../assets/b7.png';
import b8Image from '../assets/b8.png';
import b9Image from '../assets/b9.png';
import b10Image from '../assets/b10.png';
import b11Image from '../assets/b11.png';
import b12Image from '../assets/b12.png';
import b13Image from '../assets/b13.png';
import b14Image from '../assets/b14.png';
import b15Image from '../assets/b15.png';
import b16Image from '../assets/b16.png';
import b17Image from '../assets/b17.png';
import b18Image from '../assets/b18.png';
import b19Image from '../assets/b19.png';
import b20Image from '../assets/b20.png';

const bubbles_images = [
    b1Image,
    b2Image,
    b3Image,
    b4Image,
    b5Image,
    b6Image,
    b7Image,
    b8Image,
    b9Image,
    b10Image,
    b11Image,
    b12Image,
    b13Image,
    b14Image,
    b15Image,
    b16Image,
    b17Image,
    b18Image,
    b19Image,
    b20Image
]

const peoples1 = [people1, people2, people3, people4, people5, pashalka1];
const peoples2 = [people6, people7, people8, people9, people10, pashalka2];
const peoples3 = [people1, people2, people3, people4, people5, pashalka3];
const peoples4 = [people6, people7, people8, people9, people10, pashalka1];
const peoples5 = [people1, people2, people3, people4, people5, pashalka2];
const peoples6 = [people6, people7, people8, people9, people10, pashalka3];

const waitOptions: string[] = [
    'когда ИИ научится убирать дома вместо меня',
    'Масленицу — обожраться блинов',
    'когда заработает геолокация',
    'когда его мама наконец скажет, что ему со мной повезло',
    'Данила Колбасенко',
    'доллар по 32 руб.',
    'подарок от Ю',
    'такси в аэропорт',
    'новую сплетню от лучшей подружки',
    'лета',
    'когда дочка выйдет замуж',
    'внуков',
    'свидания — ну позовите уже кто-нибудь',
    'курьера',
    'знак от вселенной',
    'когда станет легче',
    'зарплату',
    'перемен',
    'когда он напишет первым',
    'выходных',
    'когда меня выберут без кастинга',
    'новый сезон',
    'когда он одумается',
    'бразильские сериалы на Ю',
    'спокойных времён',
    'чуда',
    'пока сварится картошечка',
    'нормального мужика',
    'цветов',
    'вдохновения',
    'детей из садика',
    'любви — но без сюрпризов',
    'когда мне разрешат завести собаку',
    'когда хозяин квартиры скажет: «В этом месяце не надо денег»',
    'переезда в Москву',
    'кастинга в «Будни роддома»',
    'похода на каток',
    'когда поедем копать картошку к бабушке',
    'когда в Московском зоопарке родит панда',
    'когда алгоритм станет понятным и мои видосы начнут залетать',
    'честный контент — без фильтров и пафоса',
    'ясности, а получаю опыт',
    'когда смогу обнять его или её',
    'когда малыш пойдёт в садик',
    'когда можно будет выйти из декрета',
    'новых мемов на Ю',
    'встречи с подружками',
    '«Малыш, я всё решу, не переживай»',
    'ипотеку под 3%',
    'огурцов по 87 руб.',
    'нашу встречу',
    'алименты',
    'трамвай',
    'когда очередь начнёт двигаться',
    'пока чай остынет',
    'скидки',
    'когда скинет денег на ноготочки',
    'когда уроки закончатся',
    'когда начальник выпишет премию',
];

const TARGET_DATES = [
    '12.03.2026 18:00',
    '19.03.2026 18:00',
    '26.03.2026 18:00',
    '02.04.2026 18:00',
    '09.04.2026 18:00',
    '16.04.2026 18:00',
    '23.04.2026 18:00',
    '30.04.2026 18:00',
    '07.05.2026 18:00',
    '14.05.2026 18:00',
    '21.05.2026 18:00',
    '28.05.2026 18:00',
    '04.06.2026 18:00',
    '11.06.2026 18:00',
    '18.06.2026 18:00',
    '25.06.2026 18:00',
];
function parseRuDateTime(str: string): Date {
    const [datePart, timePart] = str.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes);
}

function useMultiCountdown(targets: string[]) {
    const [currentIndex, setCurrentIndex] = React.useState(() => {
        const now = new Date();
        const idx = targets.findIndex((t) => parseRuDateTime(t) > now);
        return idx === -1 ? targets.length - 1 : idx;
    });

    const currentTarget = targets[currentIndex] ?? targets[targets.length - 1];

    const countdown = useCountdown(currentTarget);

    React.useEffect(() => {
        const targetDate = parseRuDateTime(currentTarget);
        const now = new Date();

        if (now >= targetDate && currentIndex < targets.length - 1) {
            setCurrentIndex((i) => Math.min(i + 1, targets.length - 1));
        }
    }, [currentTarget, currentIndex, targets.length, countdown.days, countdown.hours, countdown.minutes]);

    return countdown;
}

function shuffleArray<T>(array: T[]): T[] {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}
function declension(num: number, forms: [string, string, string]) {
    const n = Math.abs(num) % 100;
    const n1 = n % 10;

    if (n > 10 && n < 20) return forms[2];
    if (n1 > 1 && n1 < 5) return forms[1];
    if (n1 === 1) return forms[0];
    return forms[2];
}

const numberFormatter = new Intl.NumberFormat('ru-RU');

export function formatThousands(value: number): string {
    return numberFormatter.format(value);
}

export function isNightFunc(date: Date = new Date()): boolean {
    const hour = date.getHours();
    return hour >= 18 || hour < 6;
}

function getUserIdFromQuery(): string | null {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    return params.get('userid');
}

function convertToMinutes(value: number, type: string): number {
    switch (type) {
        case 'Минут':
            return value;
        case 'Часов':
            return value * 60;
        case 'Дней':
            return value * 60 * 24;
        case 'Месяцев':
            return value * 60 * 24 * 30;
        case 'Лет':
            return value * 60 * 24 * 365;
        default:
            return value;
    }
}

function formatDurationFromMinutes(totalMinutes: number): string {
    if (totalMinutes <= 0) return '0 минут';

    const minutesInYear = 60 * 24 * 365;
    const minutesInMonth = 60 * 24 * 30;
    const minutesInDay = 60 * 24;
    const minutesInHour = 60;

    const years = Math.floor(totalMinutes / minutesInYear);
    const remAfterYears = totalMinutes % minutesInYear;

    const months = Math.floor(remAfterYears / minutesInMonth);
    const remAfterMonths = remAfterYears % minutesInMonth;

    const days = Math.floor(remAfterMonths / minutesInDay);
    const remAfterDays = remAfterMonths % minutesInDay;

    const hours = Math.floor(remAfterDays / minutesInHour);
    const minutes = remAfterDays % minutesInHour;

    if (years >= 1) {
        const y = years;
        if (y === 1) return '1 год';
        if (y >= 2 && y <= 4) return `${y} года`;
        return `${y} лет`;
    }

    if (months >= 1) {
        const m = months;
        if (m === 1) return '1 месяц';
        if (m >= 2 && m <= 4) return `${m} месяца`;
        return `${m} месяцев`;
    }

    if (days >= 1) {
        const d = days;
        if (d === 1) return '1 день';
        if (d >= 2 && d <= 4) return `${d} дня`;
        return `${d} дней`;
    }

    if (hours >= 1) {
        const h = hours;
        if (h === 1) return '1 час';
        if (h >= 2 && h <= 4) return `${h} часа`;
        return `${h} часов`;
    }

    const mm = minutes;
    if (mm === 1) return '1 минута';
    if (mm >= 2 && mm <= 4) return `${mm} минуты`;
    return `${mm} минут`;
}

type QueueScreenProps = {
    initialUserData: UserQueueData | null;
    lastTicket: number | null;
};

var MAX_OFFSET = 0

export async function shareToVK(shareImgUrl: string) {
    const userid = getUserIdFromQuery();
    const url = 'https://sp.u-tv.ru/zhduli/?userid='+userid;
    const title = 'Виртуальная очередь от Ю';
    const description = 'Ждёшь чего-то особенного? Становись в виртуальную очередь от Ю и участвуй в розыгрыше призов!';

    const vkUrl =
        'https://vk.com/share.php?' +
        `url=${encodeURIComponent(url)}` +
        `&title=${encodeURIComponent(title)}` +
        `&description=${encodeURIComponent(description)}` +
        `&image=${encodeURIComponent(shareImgUrl)}` +
        '&noparse=true';

    window.open(
        vkUrl,
        '',
        'toolbar=0,status=0,width=626,height=436'
    );
}
function pluralizeHours(n: number): string {
    const abs = Math.abs(n);
    const n100 = abs % 100;
    if (n100 >= 11 && n100 <= 14) return 'часов';

    const n10 = abs % 10;
    if (n10 === 1) return 'час';
    if (n10 >= 2 && n10 <= 4) return 'часа';
    return 'часов';
}


export const QueueScreen: React.FC<QueueScreenProps> = ({
                                                            initialUserData,
                                                            lastTicket,
                                                        }) => {
    const [fullCount, setFullCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [showWaitSelectListTitle, setShowWaitSelectListTitle] = useState<string>('Я жду...');
    const [showTypeSelectListTitle, setShowTypeSelectListTitle] = useState<string>('Часов');
    const [ticketNumber, setTicketNumber] = useState<string>('143 143');
    const [headerTicket, setHeaderTicket] = useState<string>('');
    const [headerTicketWinner, setHeaderTicketWinner] = useState<string>('');
    const [headerTicketNumber, setHeaderTicketNumber] = useState<string>('');
    const [showWaitSelectList, setShowWaitSelectList] = useState(false);
    const [showTypeSelectList, setShowTypeSelectList] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [winnersModalOpen, setWinnersModalOpen] = useState(false);
    const [toQueueModalOpen, setToQueueModalOpen] = useState(false);
    const [youTicketModalOpen, setYouTicketModalOpen] = useState(false);
    const [startModalOpen, setStartModalOpen] = useState(true);
    const [statModalOpen, setStatModalOpen] = useState(false);
    const [notAuthModalOpen, setNotAuthModalOpen] = useState(false);
    const [getTicketModalOpen, setGetTicketModalOpen] = useState(false);
    const { days, hours, minutes } = useMultiCountdown(TARGET_DATES);
    const [touchStartX, setTouchStartX] = useState<number | null>(null);
    const velocityRef = React.useRef(0);          // текущая скорость
    const lastTouchXRef = React.useRef<number | null>(null);
    const lastTouchTimeRef = React.useRef<number | null>(null);
    const inertiaFrameRef = React.useRef<number | null>(null);

    const [showBackButton, setShowBackButton] = useState(false);
    const [showWinnersButton, setShowWinnersButton] = useState(false);
    const scrollAnimRef = React.useRef<number | null>(null);
    const [totalHours, setTotalHours] = useState<number | null>(null);
    const [winnersList, setWinnersList] = useState<WinnerItem[]>([]);


    const [selectedWaitType, setSelectedWaitType] = useState<number | null>(null);
    const [durationValue, setDurationValue] = useState<string>('');
    const [durationType, setDurationType] = useState<
        'Часов' | 'Минут' | 'Дней' | 'Месяцев' | 'Лет'
        >('Часов');
    const [ticketImgUrl, setTicketImgUrl] = useState<string>(ticketImage);
    const [shareImgUrl, setShareImgUrl] = useState<string>("");
    const [selectedWaitText, setSelectedWaitText] = useState<string | null>(null);
    const [displayDurationText, setDisplayDurationText] =
        useState<string | null>(null);

    useEffect(() => {
        MAX_OFFSET = -10000*document.body.clientHeight/866
        console.log(MAX_OFFSET)

        const fromUser = initialUserData?.ticket ?? null;
        const candidates = [fromUser, lastTicket].filter(
            (v): v is number => typeof v === 'number'
        );
        if (candidates.length > 0) {
            setFullCount(Math.max(...candidates));
        }


        const userid = getUserIdFromQuery();
        if (!userid) {
            setNotAuthModalOpen(true)
            setStartModalOpen(false)
            return;
        }
        if (!initialUserData) return;

        const data = initialUserData;
        if (data.ticket_image_url) {
            setTicketImgUrl(data.ticket_image_url);
        }
        if (data.share_image_url) {
            setShareImgUrl(data.share_image_url);
        }
        if (typeof data.ticket === 'number') {
            setTicketNumber(formatThousands(data.ticket));
        }
        if (typeof data.duration === 'number') {
            setDisplayDurationText(formatDurationFromMinutes(data.duration));
        }
        if (typeof data.waittype === 'number') {
            const text = waitOptions[data.waittype] ?? '';
            setSelectedWaitType(data.waittype);
            setSelectedWaitText(text);
            setShowWaitSelectListTitle(text || 'Я жду...');
        }
        if (typeof data.last_ticket_in_system === 'number') {
            setFullCount(data.last_ticket_in_system)
        }


        setHeaderTicket('ticket');
        setStartModalOpen(false);

        return () => {
            if (scrollAnimRef.current !== null) {
                cancelAnimationFrame(scrollAnimRef.current);
            }
        };
    }, [initialUserData, lastTicket]);

    const shuffledPeoples1 = useMemo(() => shuffleArray(peoples1), []);
    const shuffledPeoples2 = useMemo(() => shuffleArray(peoples2), []);
    const shuffledPeoples3 = useMemo(() => shuffleArray(peoples3), []);
    const shuffledPeoples4 = useMemo(() => shuffleArray(peoples4), []);
    const shuffledPeoples5 = useMemo(() => shuffleArray(peoples5), []);
    const shuffledPeoples6 = useMemo(() => shuffleArray(peoples6), []);
    const shuffledPeoples7 = useMemo(() => shuffleArray(peoples1), []);
    const shuffledPeoples8 = useMemo(() => shuffleArray(peoples2), []);
    const shuffledPeoples9 = useMemo(() => shuffleArray(peoples3), []);
    const shuffledPeoples10 = useMemo(() => shuffleArray(peoples4), []);
    const shuffledPeoples11 = useMemo(() => shuffleArray(peoples5), []);
    const shuffledPeoples12 = useMemo(() => shuffleArray(peoples6), []);
    const shuffledPeoples = useMemo(
        () => [
            ...shuffledPeoples1,
            ...shuffledPeoples2,
            ...shuffledPeoples3,
            ...shuffledPeoples4,
            ...shuffledPeoples5,
            ...shuffledPeoples6,
            ...shuffledPeoples7,
            ...shuffledPeoples8,
            ...shuffledPeoples9,
            ...shuffledPeoples10,
            ...shuffledPeoples11,
            ...shuffledPeoples12,
        ],
        [
            shuffledPeoples1,
            shuffledPeoples2,
            shuffledPeoples3,
            shuffledPeoples4,
            shuffledPeoples5,
            shuffledPeoples6,
            shuffledPeoples7,
            shuffledPeoples8,
            shuffledPeoples9,
            shuffledPeoples10,
            shuffledPeoples11,
            shuffledPeoples12,
        ]
    );

    // const bubbleFlags = useMemo(
    //     () =>
    //         shuffledPeoples.map(() => Math.floor(Math.random() * 20) + 1 === 5),
    //     [shuffledPeoples]
    // );

    // const bubbleIndexes = useMemo(
    //     () =>
    //         shuffledPeoples.map(() => Math.floor(Math.random() * bubbles_images.length)),
    //     [shuffledPeoples]
    // );




    const bubbleFlags = useMemo(() => {
        const len = shuffledPeoples.length;
        const flags = Array<boolean>(len).fill(false);

        if (len <= 1) return flags;

        let i = 1 + Math.floor(Math.random() * 3); // старт где‑то между 1 и 3

        while (i < len) {
            flags[i] = true;
            const step = 3 + Math.floor(Math.random() * 5); // 3..7
            i += step;
        }

        return flags;
    }, [shuffledPeoples]);

    const bubbleIndexes = useMemo(() => {
        const len = shuffledPeoples.length;
        const count = shuffledPeoples.filter((_, i) => bubbleFlags[i]).length;

        const available: number[] = [];
        for (let i = 0; i < bubbles_images.length; i++) {
            available.push(i);
        }

        const useCount = Math.min(count, available.length);

        for (let i = available.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const tmp = available[i];
            available[i] = available[j];
            available[j] = tmp;
        }

        const result: number[] = new Array(len).fill(0);
        let bubbleIdx = 0;

        for (let i = 0; i < len; i++) {
            if (!bubbleFlags[i]) continue;

            if (bubbleIdx < useCount) {
                result[i] = available[bubbleIdx];
                bubbleIdx += 1;
            } else {
                result[i] = available[useCount - 1];
            }
        }

        return result;
    }, [shuffledPeoples, bubbleFlags, bubbles_images.length]);



    const getWinners = async () => {
        try {
            const res = await fetch('https://zhduliapi.flami-dev.ru/custom-data');
            const data = await res.json();
            const winners: WinnerItem[] = data.winners
            if (winners.length > 0){
                setShowWinnersButton(true)
                setHeaderTicketWinner("winner")
                setHeaderTicketNumber(formatThousands(winners[winners.length - 1].ticket));
            }
            setWinnersList(winners)
        }catch (e){

        }

    }

    useEffect(() => {
        const fetchAgg = async () => {
            try {
                const res = await fetch('https://zhduliapi.flami-dev.ru/users/agg/by-waittype');
                if (!res.ok) {
                    console.error('Ошибка GET /users/agg/by-waittype', res.status);
                    return;
                }
                const data: WaittypeAggItem[] = await res.json();

                const totalMinutes = data.reduce(
                    (sum, item) => sum + (item.total_duration || 0),
                    0
                );
                const hours = Math.ceil(totalMinutes / 60);
                setTotalHours(hours);
            } catch (e) {
                console.error('Ошибка /users/agg/by-waittype', e);
            }
        };

        getWinners()
        fetchAgg();
    }, []);

    const handleWheel = useCallback(
        (event: React.WheelEvent<HTMLDivElement>) => {
            if (!infoModalOpen && !toQueueModalOpen) {
                const step = event.deltaY;
                updateOffset(-step);
            }
        },
        [infoModalOpen, toQueueModalOpen]
    );


    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const touch = e.touches[0];
        const x = touch.clientX;
        setTouchStartX(x);
        lastTouchXRef.current = x;
        lastTouchTimeRef.current = performance.now();
        velocityRef.current = 0;

        if (inertiaFrameRef.current !== null) {
            cancelAnimationFrame(inertiaFrameRef.current);
            inertiaFrameRef.current = null;
        }
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        if (touchStartX == null) return;
        if (infoModalOpen || toQueueModalOpen) return;

        const touch = e.touches[0];
        const currentX = touch.clientX;
        const now = performance.now();

        const lastX = lastTouchXRef.current ?? currentX;
        const lastTime = lastTouchTimeRef.current ?? now;

        const deltaX = currentX - lastX;
        const deltaTime = now - lastTime || 1;

        const velocity = deltaX / deltaTime;
        velocityRef.current = velocity;

        setOffset(prev => {
            let next = prev + deltaX;

            if (next > 0) next = 0;
            if (next < MAX_OFFSET) next = MAX_OFFSET;

            setShowBackButton(next <= -200);
            return next;
        });

        lastTouchXRef.current = currentX;
        lastTouchTimeRef.current = now;
    };


    const handleTouchEnd = () => {
        setTouchStartX(null);
        lastTouchXRef.current = null;
        lastTouchTimeRef.current = null;

        const friction = 0.95;
        const minVelocity = 0.01;
        const maxSteps = 300;

        let step = 0;

        const animate = () => {
            let v = velocityRef.current;
            if (Math.abs(v) < minVelocity || step > maxSteps) {
                inertiaFrameRef.current = null;
                return;
            }

            const deltaX = v * 16;

            setOffset((prev) => {
                let next = prev + deltaX;
                if (next > 0) next = 0;
                if (next < MAX_OFFSET) next = MAX_OFFSET;
                return next;
            });

            velocityRef.current = v * friction;
            step += 1;
            inertiaFrameRef.current = requestAnimationFrame(animate);
        };

        inertiaFrameRef.current = requestAnimationFrame(animate);
    };
    const updateOffset = (delta: number) => {
        setOffset(prev => {
            let next = prev + delta;
            if (next > 0) next = 0;
            if (next < MAX_OFFSET) next = MAX_OFFSET;

            setShowBackButton(next <= -200);
            return next;
        });
    };
    const handleBackToStart = () => {
        if (scrollAnimRef.current !== null) {
            cancelAnimationFrame(scrollAnimRef.current);
        }

        const duration = 500; // мс
        const start = performance.now();
        const startOffset = offset;

        const animate = (time: number) => {
            const elapsed = time - start;
            const t = Math.min(1, elapsed / duration); // 0..1

            const eased = 1 - (1 - t) * (1 - t);

            const next = startOffset + (0 - startOffset) * eased;
            setOffset(next);

            if (t < 1) {
                scrollAnimRef.current = requestAnimationFrame(animate);
            } else {
                scrollAnimRef.current = null;
                setShowBackButton(false);
            }
        };

        scrollAnimRef.current = requestAnimationFrame(animate);
    };


    const handleWaitSelectItemClick = (ind: number, str: string) => {
        setShowWaitSelectList(false);
        setShowWaitSelectListTitle(str);
        setSelectedWaitType(ind);
        setSelectedWaitText(str);
    };

    const handleTypeSelectItemClick = (
        str: 'Часов' | 'Минут' | 'Дней' | 'Месяцев' | 'Лет'
    ) => {
        setShowTypeSelectList(false);
        setShowTypeSelectListTitle(str);
        setDurationType(str);
    };

    const housesBackOffset = offset * 0.5;
    const housesOffset = offset * 0.6;
    const shopOffset = offset * 1;
    const roadOffset = offset * 1;

    const handleToQueueClick = async () => {
        const userid = getUserIdFromQuery();
        if (!userid) {
            console.error('userid не найден в query');
            return;
        }
        if (selectedWaitType === null) {
            console.error('waittype не выбран');
            return;
        }
        const numericDuration = Number(durationValue);
        if (!numericDuration || Number.isNaN(numericDuration)) {
            console.error('Некорректная длительность');
            return;
        }

        const durationInMinutes = convertToMinutes(numericDuration, durationType);

        try {
            const response = await fetch('https://zhduliapi.flami-dev.ru/users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userid,
                    waittype: selectedWaitType,
                    duration: durationInMinutes,
                }),
            });

            if (!response.ok) {
                console.error('Ошибка ответа сервера', response.status);
                return;
            }

            const data = await response.json();
            if (data.ticket_image_url) {
                setTicketImgUrl(data.ticket_image_url);
            }
            if (data.share_image_url) {
                setShareImgUrl(data.share_image_url);
            }
            if (typeof data.ticket === 'number') {
                setTicketNumber(formatThousands(data.ticket));
            }
            if (typeof data.duration === 'number') {
                setDisplayDurationText(formatDurationFromMinutes(data.duration));
            }
            if (!selectedWaitText && typeof data.waittype === 'number') {
                const text = waitOptions[data.waittype] ?? '';
                setSelectedWaitText(text);
                setShowWaitSelectListTitle(text || 'Я жду...');
            }

            setToQueueModalOpen(false);
            setGetTicketModalOpen(true);
        } catch (e) {
            console.error('Ошибка запроса', e);
        }
    };



    return (
        <div
            className="QueueScreen"
            onWheel={handleWheel}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {isNightFunc() ? (
                <>
                    <div className="QueueScreenBg" style={{ backgroundImage: `url(${openNightBg})` }}></div>
                    <div className="QueueScreenHousesBackBg" style={{backgroundImage: `url(${housesNightBackBg})`, backgroundPositionX: `${housesBackOffset}px`,}}></div>
                    <div className="QueueScreenHousesBg" style={{backgroundImage: `url(${housesNightBg})`, backgroundPositionX: `${housesOffset}px`,}}></div>
                </>
            ) : (
                <>
                    <div className="QueueScreenBg" style={{ backgroundImage: `url(${openBg})` }}></div>
                    <div className="QueueScreenHousesBackBg" style={{backgroundImage: `url(${housesBackBg})`, backgroundPositionX: `${housesBackOffset}px`,}}></div>
                    <div className="QueueScreenHousesBg" style={{backgroundImage: `url(${housesBg})`, backgroundPositionX: `${housesOffset}px`,}}></div>
                </>
            )}
            {totalHours !== null && (
                <div className="QueueScreen-totalHours">
                    <img src={airImage} alt=""/>
                    <span>
                    <b>{totalHours}</b> {pluralizeHours(totalHours)}<br/>
                    общее время ожидания
                        </span>
                </div>
            )}

            <div className="QueueScreenBilboardBg" style={{backgroundImage: `url(${bilboardImage})`, backgroundPositionX: `${shopOffset}px`,}}></div>
            <div className="QueueScreenShopBg" style={{backgroundImage: `url(${shopImage})`, backgroundPositionX: `${shopOffset}px`,}}></div>

            {isNightFunc() ? (
                <div className="QueueScreenRoadBg" style={{backgroundImage: `url(${roadNightImage})`, backgroundPositionX: `${roadOffset}px`,}}></div>
            ) : (
                <div className="QueueScreenRoadBg" style={{backgroundImage: `url(${roadImage})`, backgroundPositionX: `${roadOffset}px`,}}></div>
            )}

            <div className="QueueScreenPeoples" style={{ transform: 'translateX(' + roadOffset + 'px)' }}>
                {shuffledPeoples.map((src, index) => {
                    const showSecond = bubbleFlags[index];
                    const bubbleIndex = bubbleIndexes[index];

                    return (
                        <div className="QueueScreenPerson" key={index}>
                            <img src={src} alt={`person-${index + 1}`} />
                            {showSecond && index>0 && (
                                <img
                                    src={bubbles_images[bubbleIndex]}
                                    alt={`person-extra-${index + 1}`}
                                    className="QueueScreenPerson-second"
                                />
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="stolbButtons">
                <img className="stolb" style={{ transform: 'translateX(' + roadOffset + 'px)' }} alt="stolb" src={stolb}/>
                <img className="BlueBtn" style={{ transform: 'translateX(' + roadOffset + 'px)' }} alt="BlueBtn" src={blue_btn}/>
                <img className="PinkBtn" style={{ transform: 'translateX(' + roadOffset + 'px)' }} alt="PinkBtn" onClick={() => setInfoModalOpen(true)} src={pink_btn}/>
            </div>

            <header className={'QueueScreen-header ' + headerTicket + ' ' + headerTicketWinner}>
                <div className="QueueScreen-logo">
                    <img src={logoImage} alt="logo" />
                </div>
                <div className="QueueScreen-headerItem" onClick={() => setYouTicketModalOpen(true)}>
                    <img src={ticketTopImage} className="ticketTopImage" alt="" />
                    <img src={mobile_header_ticket} className="mobile_header_ticket" alt="" />
                    <span>{ticketNumber}</span>
                </div>
                <div className="QueueScreen-headerItem">
                    <img src={counterImage} alt="" />
                    <span>{formatThousands(fullCount)}</span>
                </div>
                <div className="QueueScreen-headerItem" style={{display:"none"}}>
                    <img src={timerImage} alt="" />
                    <div className="QueueScreen-timer">
                        <span>{days}<small>{declension(Number(days), ['день', 'дня', 'дней'])}</small></span>
                        <span>{hours}<small>{declension(Number(hours), ['час', 'часа', 'часов'])}</small></span>
                        <span>{minutes}<small>{declension(Number(minutes), ['минута', 'минуты', 'минут'])}</small></span>
                    </div>
                </div>
                <div className="QueueScreen-headerItem">
                    <img src={winnerTopImage} alt="" />
                    <div className="QueueScreen-timer">
                        <span>{headerTicketNumber}<small>билет</small></span>
                    </div>
                </div>
                <div className="QueueScreen-headerItem">
                    <img src={bannerImage} className="desktop-banner" alt="" />
                    <img src={bannerPadImage} className="pad-banner" alt="" />
                </div>
                <div className="QueueScreen-headerItem" onClick={()=>setStatModalOpen(true)}>
                    <img src={stat_btn} alt="" />
                </div>
            </header>
            {showBackButton && (
                <img src={ic_back} alt="ic_back" className="QueueScreen-backBtn" onClick={handleBackToStart}/>
            )}
            {showWinnersButton && (
                <img src={winnersBtn} alt="ic_back" className="QueueScreen-winnersBtn" onClick={()=>setWinnersModalOpen(true)}/>
            )}
            {youTicketModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow YouTicketModal">
                        <h2 className="ModalTitle">Ваш талончик:</h2>
                        <div className="YouTicketModal-data">
                            <img src={ticketImgUrl} alt="" />
                            <div className="YouTicketModal-dataRight">
                                <div className="YouTicketModal-dataRightItem">
                                    <b>Я жду:</b>
                                    <span>{selectedWaitText ?? '...'}</span>
                                </div>
                                <div className="YouTicketModal-dataRightItem">
                                    <b>Жду уже:</b>
                                    <span>{displayDurationText ?? '...'}</span>
                                </div>
                            </div>
                        </div>
                        <h2 className="ModalTitle footerTitle">
                            <img src={logoImage} alt="" />
                            подарков от Ю
                        </h2>
                        <div className="ShareBtn" onClick={() => {setGetTicketModalOpen(false);setHeaderTicket('ticket');shareToVK(shareImgUrl)}}>
                            Поделиться
                        </div>
                        <button className="ModalCloseButton" onClick={() => setYouTicketModalOpen(false)}>
                            <img src={close} alt="" />
                        </button>
                    </div>
                </div>
            )}

            {statModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow StatModal">
                        <h2 className="ModalTitle" style={{"textAlign":"center"}}>Статистика</h2>
                        <div className="StatModalBlocks">
                            <div className="StatModalBlock">
                                <img src={mobileCounter} alt=""/>
                                <span>{formatThousands(fullCount)}</span>
                            </div>
                            <div className="StatModalBlock">
                                <img src={mobileWinner} alt=""/>
                                <div className="QueueScreen-timer mobileWinnerBlock">
                                    <span>{headerTicketNumber}<small>билет</small></span>
                                </div>
                            </div>
                            {/*<div className="StatModalBlock">*/}
                            {/*    <img src={mobileTimer} alt=""/>*/}
                            {/*    <div className="QueueScreen-timer">*/}
                            {/*        <span>{days}<small>{declension(Number(days), ['день', 'дня', 'дней'])}</small></span>*/}
                            {/*        <span>{hours}<small>{declension(Number(hours), ['час', 'часа', 'часов'])}</small></span>*/}
                            {/*        <span>{minutes}<small>{declension(Number(minutes), ['минута', 'минуты', 'минут'])}</small></span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                        <button className="ModalCloseButton" onClick={() => setStatModalOpen(false)}>
                            <img src={close} alt="" />
                        </button>
                    </div>
                </div>
            )}

            {infoModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow InfoModal">
                        <h2 className="ModalTitle">Правила и призы</h2>
                        <div className="ModalText">
                            <ul>
                                <li><b>Авторизуйся</b> на сайте.</li>
                                <li><b>Поделись,</b> чего и сколько ты ждёшь, чтобы занять место в&nbsp;очереди.</li>
                                <li><b>Получи</b> счастливый билет и жди розыгрыша.</li>
                            </ul>
                            Каждый четверг <b>в 18:00</b> мы случайным образом выбираем победителя. <b>Проверяй результаты</b> — с счастливчиками мы свяжемся через соцсети.
                            <div className="ModalTextLinks">
                                <a href="https://www.u-tv.ru/static/pdf/confpolicy.pdf" target="_blank">Политика конфиденциальности</a>
                                <a href="https://sp.u-tv.ru/images/promo/utv/zhduli/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%BA%D0%BE%D0%BD%D0%BA%D1%83%D1%80%D1%81%D0%B0%20%D0%96%D0%B4%D1%83.pdf" target="_blank">Правила конкурса</a>
                            </div>
                        </div>
                        <button className="ModalCloseButton" onClick={() => setInfoModalOpen(false)}>
                            <img src={close} alt="" />
                        </button>
                    </div>
                </div>
            )}

            {winnersModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow InfoModal">
                        <h2 className="ModalTitle">Поздравляем!</h2>
                        <div className="ModalText">
                            С обладателями счастливого билетика мы свяжемся через социальные сети.
                            <div className="InfoModal-Table">
                                <div className="InfoModal-TableHeader">
                                    <span>Неделя</span>
                                    <span>Имя</span>
                                    <span>Номер билета</span>
                                </div>

                                {winnersList.map((winner, index) => {
                                    return (
                                        <div className="InfoModal-TableItem" key={index}>
                                            <span>{index + 1}</span>
                                            <span>{winner.name}</span>
                                            <span>№{winner.ticket}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <button className="ModalCloseButton" onClick={() => setWinnersModalOpen(false)}>
                            <img src={close} alt="" />
                        </button>
                    </div>
                </div>
            )}

            {toQueueModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow ToQueueModal">
                        Все тут чего то ждут.
                        <br />
                        А чего ждешь ты?
                        <div className="ToQueueModal-block">
                            Чего я жду?
                            <div className={(showWaitSelectList ? 'active' : '') + ' ToQueueModal-blockSelect'}>
                                <div className="ToQueueModal-blockSelectTitle" onClick={() => setShowWaitSelectList(!showWaitSelectList)}>
                                    <span>{showWaitSelectListTitle}</span>
                                    <img src={ic_arrow} alt="" />
                                </div>
                                <div className="ToQueueModal-blockSelectList">
                                    <div className="ToQueueModal-blockSelectListScroller">
                                        {waitOptions.map((text, index) => (
                                            <div key={index} className="ToQueueModal-blockSelectItem" onClick={() => handleWaitSelectItemClick(index, text)}>
                                                {text}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ToQueueModal-block">
                            <span>Как долго жду:</span>
                            <div className="ToQueueModal-blockInputs">
                                <input type="text" placeholder="0..." value={durationValue} onChange={(e) => setDurationValue(e.target.value.replace(/[^\d]/g, ''))}/>
                                <div className={(showTypeSelectList ? 'active' : '') + ' ToQueueModal-blockSelect'}>
                                    <div className="ToQueueModal-blockSelectTitle" onClick={() => setShowTypeSelectList(!showTypeSelectList)}>
                                        <span>{showTypeSelectListTitle}</span>
                                        <img src={ic_arrow} alt="" />
                                    </div>
                                    <div className="ToQueueModal-blockSelectList" style={{ height: '28.2vh' }}>
                                        <div className="ToQueueModal-blockSelectListScroller" style={{ height: 'auto', overflow: 'hidden' }}>
                                            <div className="ToQueueModal-blockSelectItem" onClick={() => handleTypeSelectItemClick('Часов')}>
                                                Часов
                                            </div>
                                            <div className="ToQueueModal-blockSelectItem" onClick={() => handleTypeSelectItemClick('Минут')}>
                                                Минут
                                            </div>
                                            <div className="ToQueueModal-blockSelectItem" onClick={() => handleTypeSelectItemClick('Дней')}>
                                                Дней
                                            </div>
                                            <div className="ToQueueModal-blockSelectItem" onClick={() => handleTypeSelectItemClick('Месяцев')}>
                                                Месяцев
                                            </div>
                                            <div className="ToQueueModal-blockSelectItem" onClick={() => handleTypeSelectItemClick('Лет')}>
                                                Лет
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="toQueueBtn" onClick={handleToQueueClick}>
                            Встать в очередь
                        </div>
                    </div>
                </div>
            )}

            {startModalOpen && (
                <>
                <div className="StartModal desktop">
                    <b>Ждёшь новый сезон реалити «Ждули»?</b>
                    <br />
                    Вставай в виртуальную очередь, расскажи,
                    <br />
                    чего ещё ты ждёшь, и выиграй призы!
                    <div className="toQueueBtn" onClick={() => {setStartModalOpen(false);setToQueueModalOpen(true);}}>
                        Встать в очередь
                    </div>
                </div>
                <div className="StartModal mobile">
                    <b>Ждёшь новый сезон реалити «Ждули»?</b>
                    <br />
                    Вставай в виртуальную очередь,
                    <br />
                    расскажи, чего ещё ты ждёшь,
                    <br />
                    и выиграй призы!
                    <div className="toQueueBtn" onClick={() => {setStartModalOpen(false);setToQueueModalOpen(true);}}>
                        Встать в очередь
                    </div>
                </div>

                </>
            )}

            {notAuthModalOpen && (
                <>
                    <div className="StartModal desktop">
                        <b>Ждёшь новый сезон реалити «Ждули»?</b>
                        <br />
                        Вставай в виртуальную очередь, расскажи,
                        <br />
                        чего ещё ты ждёшь, и выиграй призы!
                        <br />
                        <b className="notAuthText">Авторизуйся на сайте в правом верхнем<br /> углу и становись в очередь!</b>
                    </div>
                    <div className="StartModal mobile">
                        <b>Ждёшь новый сезон реалити «Ждули»?</b>
                        <br />
                        Вставай в виртуальную очередь,
                        <br />
                        расскажи, чего ещё ты ждёшь,
                        <br />
                         и выиграй призы!
                        <br />
                        <b className="notAuthText">Авторизуйся на сайте в правом<br /> верхнем углу и становись в очередь!</b>
                    </div>
                </>
            )}

            {getTicketModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalWindow GetTicketModal">
                        Ты в очереди! Сохрани билет —
                        <br />
                        возможно, он счастливый
                        <div className="GetTicketModalImage">
                            <img src={deviceImage} alt="" />
                            <div className="GetTicketModalImage-Ticket" style={{ backgroundImage: `url(${ticketImgUrl})` }}></div>
                        </div>
                        <div className="ShareBtn" onClick={() => {setGetTicketModalOpen(false);setHeaderTicket('ticket');shareToVK(shareImgUrl)}}>
                            Поделиться
                        </div>
                        <div className="SkipBtn" onClick={() => {setGetTicketModalOpen(false);setHeaderTicket('ticket');}}>
                            Далее
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
